type I18nLike = {
  locale?: string;
  defaultLocale?: string;
} | null;

export const isExternalUrl = (url = ''): boolean => /^https?:\/\//.test(url);

export const getLocalizedPath = (urlKey = '', i18n: I18nLike = null): string => {
  if (isExternalUrl(urlKey)) {
    return urlKey;
  }

  const path = `/${String(urlKey).replace(/^\/+/, '')}`;
  const locale = i18n?.locale;
  const defaultLocale = i18n?.defaultLocale;

  if (!locale || locale === defaultLocale) {
    return path;
  }

  return path === '/' ? `/${locale}/` : `/${locale}${path}`;
};
